import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../context/LanguageContext';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  background: #0d1117;
  color: white;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.2rem;
  color: #8b949e;
  margin-bottom: 2rem;
  max-width: 600px;
`;

const EarlyAccessButton = styled.a`
  display: inline-block;
  color: #0b1829;
  background: #28c0ef;
  padding: 0.75rem 1.5rem;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    background: #50c1ff;
  }
`;

const NotAvailablePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Title>{t('Authorized Access Required')}</Title>
      <Message>
        {t('Sorry, it seems you don\'t have authorized access to Spark yet. Join our exclusive early access group to be among the first educators to experience our AI-powered platform!')}
      </Message>
      <EarlyAccessButton
        href="https://sparkskool.com/beta"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('Get Early Access')}
      </EarlyAccessButton>
    </Container>
  );
};

export default NotAvailablePage; 
